// extracted by mini-css-extract-plugin
export var backgroundImage = "expert-module--backgroundImage--06940";
export var expertArticlesGrid = "expert-module--expert-articles-grid--e7e12";
export var expertContent = "expert-module--expert-content--06028";
export var expertContentInner = "expert-module--expert-content-inner--c4f49";
export var expertImageWrapper = "expert-module--expert-image-wrapper--378cf";
export var expertPhoto = "expert-module--expert-photo--d8911";
export var intro = "expert-module--intro--fab4e";
export var mijnMkb = "expert-module--mijn-mkb--83537";
export var social = "expert-module--social--7af6c";